/**
 * @description Componente de mensagem de boas-vindas do dashboard
 * @module WelcomeMessage
 * @since Fevereiro 2024
 */

import React from "react";
import { Paper, Typography } from "@mui/material";

interface WelcomeMessageProps {
  userName?: string;
}

export const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ userName }) => (
  <Paper sx={{ p: 2, mb: 2, bgcolor: "#00A884", color: "white" }}>
    <Typography variant="h6" gutterBottom>
      Olá, {userName}
    </Typography>
    <Typography variant="body2">Bem-vindo ao FluxVet</Typography>
  </Paper>
);
